module.exports = __webpack_public_path__ + "img/ga.d0289dc0.png";